module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAkUlEQVQ4T62T0Q3DMAgFjzUyQPfoHhkgI2WAztHskQGyxouQnEpVwUVy/GMJwwHPYJIewArMZnZQOJIm4AUsJukNPIHd73+QFrwBnnhzgNMuQxcS+nrFFUjmY1fLPUjv7QPIKmkJ0ha/AAnEzS5YqM8PIIC4KRX3fkAgWL2FSO2yiEPfODRIleDusN2xTEPrfAKQi5f7ADVi4QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/delete.png
// module id = KuaY
// module chunks = 1 2